import { Equal, IQueryCommandOptions, Not } from '@llws/dynamic-router-utils';
import { IFloorplanNavigatorPresetFilters } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_preset_filters';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'id',
    'field',
    'label',
    'value',
    'match',
    'increments',
    'customFieldKey',
    'customFieldTarget',
    'size',
    'filterStyle',
    'transform',
    'status',
    'order',
  ],
  alias: 'f',
  where: [ Not(Equal('status', 'deleted')) ],
  orderBy: [{ field: 'order', direction: 'asc' }],
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'id',
    'field',
    'label',
    'value',
    'match',
    'increments',
    'customFieldKey',
    'customFieldTarget',
    'size',
    'filterStyle',
    'transform',
    'status',
    'order',
  ],
  alias: 'fnpf',
  where: [ Not(Equal('status', 'deleted')) ],
};
const base = new StoreBaseImplementationV2<Partial<IFloorplanNavigatorPresetFilters>>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
